
export function useSlideTitle() {
  return 'Weekly crop commodity prices - overview';
}